import { ADD_SERVICE, CHANGE_CLOUD, CHANGE_REGISTRY, CHANGE_SERVICES } from './constants';

export const changeCloud = (cloud) => ({ type: CHANGE_CLOUD, payload: cloud });
export const changeService = (service) => ({ type: CHANGE_SERVICES, payload: service });
export const addService = (service) => ({ type: ADD_SERVICE, payload: service });
export const changeRegistry = (registry) => ({ type: CHANGE_REGISTRY, payload: registry });
